import { Directive, OnDestroy, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { OrderingOption } from 'generated/graphql-types';
import { Observable } from 'rxjs';
import { getCurrentUserIsTrueSystemUser } from 'src/app/authentication/state/authentication.selector';
import { Register } from 'src/app/common-components/register/models/register';
import { RegisterActions } from 'src/app/common-components/register/models/register-actions';
import { RegisterSelectors } from 'src/app/common-components/register/models/register-selectors';
import { getHangUpCallsPrivileges } from 'src/app/privileges/privileges.selector';
import { ActiveCallsFilterOptions } from './models/active-calls-filter-option';
import { ActiveCallsOrderingOptions, ActiveCallsRegisterOptions } from './models/active-calls-register-options';
import { ActiveCallsRegisterListItem } from './models/active-calls-register-results.model';
import { HangUpCallsPrivileges } from './models/hang-up-calls.privileges';

@Directive()
export abstract class ActiveCallsRegister
   extends Register<ActiveCallsRegisterListItem, ActiveCallsRegisterOptions, ActiveCallsOrderingOptions>
   implements OnInit, OnDestroy
{
   columns: string[];
   filters: ActiveCallsFilterOptions[];

   entityName = 'Active Call';
   hangupActiveCallsPrivileges$: Observable<HangUpCallsPrivileges>;
   isSystemUser$: Observable<boolean>;

   constructor(
      public store: Store,
      selectors: RegisterSelectors<ActiveCallsRegisterListItem, object, ActiveCallsRegisterOptions, OrderingOption>,
      adapterActions: RegisterActions<ActiveCallsRegisterListItem>
   ) {
      super(store, selectors, adapterActions);
      this.hangupActiveCallsPrivileges$ = store.pipe(select(getHangUpCallsPrivileges));
      this.isSystemUser$ = store.pipe(select(getCurrentUserIsTrueSystemUser));
   }

   ngOnInit() {
      this.store.dispatch(this.getInitialFilterAction());
      super.ngOnInit();
   }

   ngOnDestroy() {
      super.ngOnDestroy();
   }

   abstract getInitialFilterAction(): any;

   onCreate(): void {
      this.store.dispatch(this.getCreateAction());
   }

   abstract getCreateAction(): any;
}
